export function init() {
	Array.from(document.querySelectorAll('.js-faux-block-link')).forEach(element => {
		element.style.cursor = 'pointer';
		element.addEventListener('click', onClick, true);
	});
}

function onClick(event) {
	if (event.target.closest('.js-faux-block-link a, .js-faux-block-link button')) {
		return;
	}

	let target = event.currentTarget.querySelector('.js-faux-block-link-target');

	window.location = target.href;
}
